import Controller from "@ember/controller";

export default class extends Controller {
  get project() {
    return this.model.project;
  }
}
